<template>
  <div>
    <div class="section-header">
      <h1 class="section-header__title">Travel</h1>
      <p class="section-header__subtitle">Destinations & travel experiences</p>
    </div>

    <SearchableList section="travel" :per-page="20" />
  </div>
</template>

<script>
import SearchableList from '../Shared/SearchableList.vue'

export default {
  components: { SearchableList },
  props: {
    algoliaFilter: { type: String, default: '' },
    experiences: { type: Array, default: () => [] },
    perks: { type: Array, default: () => [] },
    featuredCities: { type: Array, default: () => [] },
    isGuest: { type: Boolean, default: false }
  }
}
</script>
